import { urls } from './../../config';
import authFetch from './../../utils/authFetch';

import { ordersDetailsReceive } from './../orders/actions';

export const ORDER_SINGLE_REQUEST = 'ORDER_SINGLE_REQUEST';
export const ORDER_SINGLE_RECEIVE = 'ORDER_SINGLE_RECEIVE';
export const ORDER_SINGLE_ERROR = 'ORDER_SINGLE_ERROR';

const orderSingleRequest = () => ({
    type: ORDER_SINGLE_REQUEST
});

const orderSingleReceive = number => ({
    type: ORDER_SINGLE_RECEIVE,
    number
});

const orderSingleError = () => ({
    type: ORDER_SINGLE_ERROR
});

export const orderSingleFetch = id => {
    return (dispatch, getState) => {
        dispatch(orderSingleRequest());
        return authFetch(`${urls.orders}/${id}`).then(json => {
            dispatch(ordersDetailsReceive(json.number, json));
            dispatch(orderSingleReceive(json.number));
        }).catch(error => dispatch(orderSingleError()));
    };
};


// WEBPACK FOOTER //
// ./src/store/orderSingle/actions.js